<script>
import { mapActions, mapState } from 'vuex';
import TwBreadcrumbs from './TwBreadcrumbs';

export default {
  components: {
    TwBreadcrumbs,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    breadcrumbs: {
      type: Array,
      required: false,
      default: null,
    },
    domains: {
      type: Array,
      required: false,
      default: () => [],
    },
    shouldShowDomainSelector: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      selectedDomainId: state => state.ski.selectedDomainId,
    }),
  },
  methods: {
    ...mapActions({
      setSelectedDomainId: 'ski/setSelectedDomainId',
    }),
  },
};
</script>

<template>
  <div class="tw-title-bar">
    <v-list class="px-0 py-0">
      <v-list-tile>
        <v-list-tile-title class="title pb-0">
          {{ title }}
        </v-list-tile-title>
        <v-select
          v-if="shouldShowDomainSelector"
          :loading="!domains.length"
          :items="domains"
          :value="selectedDomainId"
          item-text="name"
          item-value="id"
          label="Domain"
          hide-details
          dense
          outlined
          class="tw-title-bar__domain-select"
          @input="setSelectedDomainId($event)"
        />
      </v-list-tile>
      <v-list-tile v-if="breadcrumbs">
        <tw-breadcrumbs :items="breadcrumbs"/>
      </v-list-tile>
    </v-list>
    <v-divider/>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/TwTitleBar.vue